/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreatePromosDto { 
    /**
     * Code of promo (e.g., VIP001) - maximum 12 characters
     */
    code: string;
    /**
     * Type of promo (percent / amount)
     */
    type: string;
    /**
     * Discount value (e.g., 10) - for percent, must be 1-99
     */
    value: number;
    /**
     * Usage limit (must be greater than 0)
     */
    usageLimit: number;
    /**
     * Expiration date (must not be in the past)
     */
    expirationDate: string;
    /**
     * Is the promo active?
     */
    isActive: boolean;
    /**
     * Created by organizer ID
     */
    createdById: string;
}

